import React from 'react';

export default ({ wrappedComponent, active, onBackgroundClick }) => {
    const menuWrapperStyle = {
        top: 'auto',
        bottom: 0,
        padding: '0 2rem',
        transition: '1s',
        maxHeight: '90%',
        overflowY: 'auto'
    };

    const dialogStyle = {
        borderRadius: '5px 5px 0 0',
        backgroundColor: '#fff',
        padding: '2rem'
    };

    return (
        <div>
            <div
                className={`mobile-slide-up-modal-background ${
                    active ? 'active' : ''
                }`}
                onClick={onBackgroundClick ? onBackgroundClick : () => {}}
            />
            <div
                className={`mobile-slide-up-modal-wrapper mobile-slide-up-modal-animation ${
                    active ? 'active' : ''
                }`}
                style={menuWrapperStyle}
                data-myt-list-more-menu-content>
                <div style={dialogStyle}>{wrappedComponent}</div>
            </div>
        </div>
    );
};



// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/components/modals/mobile-slide-up-modal.jsx